export const thresholdDerzhatel = 5;

export function addDerzhatelBlock(counter, autoCheck = true) {
    const container = document.querySelector(".full_width__derzhatel_rulona_wrap");
    const template = container.querySelector(".derzhatel_rulona_block__1");

    const clone = template.cloneNode(true);
    clone.classList.forEach((cls) => {
        if (cls.startsWith("derzhatel_rulona_block__")) {
            clone.classList.replace(cls, `derzhatel_rulona_block__${counter}`);
        }
    });

    // Обновление name и классов внутри клона
    clone.querySelectorAll("input").forEach((input) => {
        const oldName = input.getAttribute("name");
        if (oldName) {
            const newName = oldName.replace(/__(\d+)$/, `__${counter}`);
            input.setAttribute("name", newName);
            input.checked = false;
            input.disabled = false;
        }
    });

    // Обновляем классы обертки фиксаторов
    const fiksatoriWrap = clone.querySelector(".bokovie_fiksatori_wrap__1");
    if (fiksatoriWrap) {
        fiksatoriWrap.classList.replace("bokovie_fiksatori_wrap__1", `bokovie_fiksatori_wrap__${counter}`);
        fiksatoriWrap.classList.add("disable");
    }

    // Вставляем перед кнопкой
    const addBtn = container.querySelector(".add_derzhatel");
    container.insertBefore(clone, addBtn);

    // Обрабатываем держатель
    const derzhatelInput = clone.querySelector(`input[name="derzhatel_rulona__${counter}"]`);
    if (derzhatelInput) {
        if (autoCheck) {
            derzhatelInput.checked = true;
            document.querySelector(`.bokovie_fiksatori_wrap__${counter}`)?.classList.remove("disable");
        }
        derzhatelInput.addEventListener("change", derzhatelHandler);
        derzhatelInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
}

function derzhatelHandler(event) {
    const target = event.target;
    const count = target.name.split("__").at(-1);
    const targetChecked = target.checked;
    const fiksatoriWrap = document.querySelector(`.bokovie_fiksatori_wrap__${count}`);

    // Управляем состоянием обертки фиксаторов
    if (targetChecked) {
        fiksatoriWrap?.classList.remove("disable");
    } else {
        // Сбрасываем чекбокс фиксаторов при отключении держателя
        const fiksatoriInput = fiksatoriWrap?.querySelector(`input[name="bokovie_fiksatori__${count}"]`);
        if (fiksatoriInput) {
            fiksatoriInput.checked = false;
            fiksatoriInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
        fiksatoriWrap?.classList.add("disable");
    }

    // Обновляем состояние кнопки добавления
    const derzhatelNodeList = document.querySelectorAll("input[name*='derzhatel_rulona__']");
    const isAnyChecked = Array.from(derzhatelNodeList).some((el) => el.checked);
    const addBtn = document.querySelector(".add_derzhatel");
    addBtn?.classList.toggle("disable", !isAnyChecked || servObj.counterDerzhatel > servObj.thresholdDerzhatel);
}

export function initDerzhatelListeners() {
    const servObj = window.servObj || parent.servObj;

    const container = document.querySelector(".full_width__derzhatel_rulona_wrap");
    servObj.thresholdDerzhatel = Number(container?.dataset.maxBlocks);

    servObj.counterDerzhatel =
        document.querySelectorAll(".derzhatel_rulona_block__1, [class*='derzhatel_rulona_block__']").length + 1;

    const btn = document.querySelector(".add_derzhatel");
    if (!btn) return;

    btn.addEventListener("pointerdown", () => {
        if (servObj.counterDerzhatel > servObj.thresholdDerzhatel) {
            btn.classList.add("disable");
            return;
        }

        // При ручном добавлении передаем true для авточека
        addDerzhatelBlock(servObj.counterDerzhatel, true);
        servObj.counterDerzhatel++;

        if (servObj.counterDerzhatel > servObj.thresholdDerzhatel) {
            btn.classList.add("disable");
        }
    });

    const firstInput = document.querySelector("input[name='derzhatel_rulona__1']");
    firstInput.addEventListener("change", derzhatelHandler);
}

export function resetDerzhatelBlocks() {
    const servObj = window.servObj || parent.servObj;
    const container = document.querySelector(".full_width__derzhatel_rulona_wrap");
    if (!container) return;

    // Оставляем только первый блок
    const blocks = container.querySelectorAll("[class*='derzhatel_rulona_block__']");
    if (!blocks) return;
    blocks.forEach((block, idx) => {
        if (idx > 0) block.remove();
    });

    servObj.counterDerzhatel = 2;

    const btn = container.querySelector(".add_derzhatel");
    btn.classList.remove("disable");
}
